<ccl-page-header>
    <div class="s-page-header__left c-page-header__left">
        <div class="c-title c-title--secondary">
            HTML
        </div>
    </div>
    <div class="s-page-header__right">
        <ccl-toggle-button
            [title]="htmlConfig.isEnabled ? 'Enable' : 'Disable'"
            [isChecked]="htmlConfig.isEnabled"
            (isCheckedChange)="toggleHTMLEnable($event)"
            >{{ htmlConfig.isEnabled ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
    </div>
</ccl-page-header>

<ccl-content-section *ngIf="htmlConfig.isEnabled">
    <div class="c-title--subsection text-uppercase">
        Layout
    </div>
    <div class="row row--builder">
        <div class="col col--builder">
            <ccl-page-section-builder
                [model]="builderService.currentSite.pages[builderService.currentPageKey].content"
            ></ccl-page-section-builder>
        </div>
    </div>
</ccl-content-section>
